// extracted by mini-css-extract-plugin
export var button = "_7-0";
export var buttonContent = "_7-e";
export var buttonGroup = "_7-c";
export var dontRestrainIconWidth = "_7-a";
export var dropdownButton = "_7-b";
export var iconContainer = "_7-9";
export var lg = "_7-4";
export var md = "_7-3";
export var pending = "_7-f";
export var sm = "_7-2";
export var spinner = "_7-d";
export var squared = "_7-8";
export var wrapText = "_7-g";
export var xl = "_7-5";
export var xs = "_7-1";
export var xxl = "_7-6";
export var xxxl = "_7-7";